import { CreateGHADiscountRuleDiscountType, GHADiscountRuleAccountType } from '~/services/ConnectionGoogleService';

export const GHA_DISCOUNT_ACCOUNT_TYPE_OPTIONS: Array<{ value: GHADiscountRuleAccountType; label: string }> = [
  { value: 'lpp', label: 'LPP' },
  { value: 'lpc', label: 'LPC' },
  { value: 'le_vacation_rental', label: 'LE Vacation Rental' },
  { value: 'scoopon', label: 'Scoopon' },
];

export const GHA_DISCOUNT_TYPE_OPTIONS: Array<{ value: CreateGHADiscountRuleDiscountType; label: string }> = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'margin_retention', label: 'Margin retention' },
];

export const GHA_DISCOUNT_MIN_ADVANCE_BOOKING_WINDOW_MAX = 300;
export const GHA_DISCOUNT_MIN_LENGTH_OF_STAY_MAX = 30;
export const MAX_PERCENTAGE_DISCOUNT = 100;
